// extracted by mini-css-extract-plugin
export var errorIcon = "_kn-1";
export var nameLogo = "_kn-0";